import { PageHeader } from "@ant-design/pro-layout";
import { Button, Descriptions, Input, Typography } from "antd";
import { useEffect, useState } from "react";

const { Title } = Typography;

interface SystemFlagsProps {
    onLoad: () => Promise<void>;
    onSave: (systemFlags: string[]) => Promise<void>;
    selectedSystemFlags: string[];
    setSelectedApplicantId: (applicantId: string) => void;
}

export const SystemFlags: React.FC<SystemFlagsProps> = (props) => {
    const [systemFlags, setSystemFlags] = useState<string[]>(props?.selectedSystemFlags ?? []);

    const handleSave = async () => {
        await props.onSave(systemFlags);
    }

    useEffect(() => {
        setSystemFlags(props?.selectedSystemFlags !== undefined ? props.selectedSystemFlags : [])   
    }, [props.selectedSystemFlags]);

    return (
        <>
        <PageHeader>
            <div id="leftTitle" >
            <Title level={3} style={{ display: 'inline' }}>
                System Flags
            </Title>
            &nbsp;&nbsp;&nbsp;&nbsp;
            </div>
        </PageHeader>
        <div style={{ padding: 24 }}>
            <div style={{ padding: '10px 0px', marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '25%' }}>
                    <Descriptions.Item>Applicant ID:</Descriptions.Item>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <Input type="text" placeholder="Applicant ID" onChange={(e) => {
                            console.log('on change applicant id ', e.target.value)
                            props.setSelectedApplicantId(e.target.value);
                        }}/>
                        <Button type="primary" onClick={async () => await props.onLoad()}>Load</Button>
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '50%' }}>
                    <Descriptions.Item>System Flags:</Descriptions.Item>
                    <textarea defaultValue={systemFlags.join(',')} onChange={(e) => {
                        console.log('value ', e.target.value)
                        if (e.target.value === '') {
                            setSystemFlags([])
                        } else {
                            setSystemFlags(e.target.value.split(','))
                        }
                    }}></textarea>
                </div>
                <div style={{ marginTop: '20px' }}>
                    <Button type="primary" onClick={handleSave}>Save</Button>
                </div>
            </div>
        </div>
        </>

        // need input for applicant user id to fetch system flags for that user

        // need text area for displaying system flags for that user and allowing user to update them

        // need button for saving updated system flags for that user
    )

}